import { FROM_QUERY_FORMAT_STRING, FROM_DISPLAYNAME_QUERY_FORMAT_STRING, TO_QUERY_FORMAT_STRING, TO_DISPLAYNAME_QUERY_FORMAT_STRING, OR_SEPARATOR, } from './searchConstants';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { format } from 'owa-strings';
export default function createPersonaSearchQueryString(personaSuggestion, searchScope) {
    var queryFormatStringForPersonaQuery;
    var queryFormatStringForPersonaDisplayNameQuery;
    var folderScopeName = 'none';
    if (searchScope.kind == "PrimaryMailbox" /* PrimaryMailbox */) {
        folderScopeName = folderIdToName(searchScope.folderId);
    }
    switch (folderScopeName) {
        case 'sentitems':
        case 'drafts':
            queryFormatStringForPersonaQuery = TO_QUERY_FORMAT_STRING;
            queryFormatStringForPersonaDisplayNameQuery = TO_DISPLAYNAME_QUERY_FORMAT_STRING;
            break;
        default:
            queryFormatStringForPersonaQuery = FROM_QUERY_FORMAT_STRING;
            queryFormatStringForPersonaDisplayNameQuery = FROM_DISPLAYNAME_QUERY_FORMAT_STRING;
            break;
    }
    var singlePersonaQueries = [];
    // Adding a From/To(DisplayName) query
    singlePersonaQueries.push(format(queryFormatStringForPersonaDisplayNameQuery, personaSuggestion.DisplayName));
    // Adding a From/To(email@address.com) query per email
    personaSuggestion.EmailAddresses.forEach(function (email) {
        singlePersonaQueries.push(format(queryFormatStringForPersonaQuery, email));
    });
    // Joining all the queries with an OR
    var singlePersonaQueryString = singlePersonaQueries.join(OR_SEPARATOR);
    return singlePersonaQueryString;
}
//# sourceMappingURL=createPersonaSearchQueryString.js.map